import React from 'react';
import BaseIcon from './BaseIcon';

const pathData = [
  'M16.5241 5.83842C16.3289 5.64315 16.0123 5.64315 15.817 5.83842L14.4028 7.25263C14.2076 7.44789',
  '14.2076 7.76447 14.4028 7.95974L15.817 9.37395L16.8777 10.4346L14.4028 12.9095C14.2076 13.1047',
  '14.2076 13.4213 14.4028 13.6166C14.5981 13.8119 14.9147 13.8119 15.1099 13.6166L17.5848',
  '11.1417C17.9753 10.7512 17.9753 10.118 17.5848 9.7275L16.8777 9.0204L17.9384 7.95974C18.1336',
  '7.76447 18.1336 7.44789 17.9384 7.25263L16.5241 5.83842ZM12.9886 8.66684C13.1839 8.47158',
  '13.5005 8.47158 13.6957 8.66684L15.1099 10.0811C15.3052 10.2763 15.3052 10.5929 15.1099',
  '10.7882L9.09953 16.7986L6.86623 17.543C6.47535 17.6733 6.10348 17.3014 6.23377 16.9105L6.97821',
  '14.6773L12.9886 8.66684Z',
].join(' ');

const SignIllustrationIcon = props => (
  <BaseIcon {...props}>
    <g stroke="none" fill="none" fillRule="evenOdd" clipRule="evenodd">
      <circle cx="12" cy="12" r="11" strokeWidth="2" stroke="currentColor" />
      <path strokeWidth="1" d={pathData} />
    </g>
  </BaseIcon>
);

export default SignIllustrationIcon;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Icons/SignIllustrationIcon.jsx